/**
 * Точка входа: шрифты, стили, тема и монтирование корня.
 *
 * Шрифты подключены пакетами `@fontsource-variable`, а не ссылкой на
 * Google Fonts: десктопное приложение под Tauri должно работать без
 * сети, а внешняя ссылка в offline-сборке просто не загрузится и
 * подменит гарнитуру системной.
 *
 * Стили Mantine подключены в CSS-слое (`styles.layer.css`): утилиты
 * Tailwind лежат вне слоёв и поэтому перекрывают их без `!important`.
 */

import '@fontsource-variable/inter';
import '@fontsource-variable/manrope';
import '@mantine/core/styles.layer.css';
import { MantineProvider } from '@mantine/core';
import { MotionConfig } from 'framer-motion';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// Подключает токены доступа к `apiRequest` до первого запроса.
import './api/auth';
// Локализация — до первого рендера: экраны сразу на языке ученика.
import './i18n';
import { useThemeStore } from './store/themeStore';
import { mantineTheme } from './theme/mantineTheme';
import './index.css';

// Service worker нужен Chromium, чтобы считать приложение устанавливаемым:
// без него `beforeinstallprompt` не приходит. Кэша нет — см. public/sw.js.
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Не найден корневой элемент #root в index.html');
}

createRoot(container).render(
  <StrictMode>
    <MantineProvider theme={mantineTheme} defaultColorScheme={useThemeStore.getState().mode}>
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </MantineProvider>
  </StrictMode>,
);
